import type { IqeStopRunResponse } from '../../interfaces/api/responses/stopRun.response';

export function isStopRunAccepted(response: IqeStopRunResponse): boolean {
  return response?.status?.trim().toLowerCase() === 'success';
}

export function toStopRunStatusUpdate(
  response: IqeStopRunResponse,
  fallbackProjectId: string,
) {
  return {
    projectId: response?.data?.projectId || fallbackProjectId,
    transactionId: response?.data?.transactionId,
    status: response?.data?.status,
  };
}
